import { theme } from '@styles';

export const cardLayoutByState = {
  [false]: {
    containerBackgroundColor: theme.colors.white[10],
    iconColor: theme.colors.alto[100],
    imageOpacity: 1,
    subtitleColor: theme.colors.white[60],
    typographyColor: theme.colors.white[100],
  },
  [true]: {
    containerBackgroundColor: theme.colors.white[5],
    iconColor: theme.colors.white[30],
    imageOpacity: 0.3,
    subtitleColor: theme.colors.white[20],
    typographyColor: theme.colors.white[30],
  },
};

export const imageLayoutByDevice = {
  laptop: {
    height: 200,
  },
  mobile: {
    height: 146,
  },
  tablet: {
    height: 160,
  },
};
